export default __webpack_public_path__ + "static/media/dinein.ba348c4b.svg";